import { CLEAR_REFERRALS, REPLACE_REFERRALS, SELECT_ALL_REFERRALS, SELECT_REFERRAL, SET_REFERRALS_FILTERS, SET_REFERRALS_PAGENUMBER, SET_REFERRALS_PAGESIZE, UNSELECT_ALL_REFERRALS, UNSELECT_REFERRAL } from "./actions"

const initialState = {
    referrals: [],
    selectedReferrals: [],
    totalResults: 0,
    totalPage: 1,
    pageSize: 10,
    pageNumber: 1,
    filters: {
        referralNumber: '',
        state: '',
        fromRemittedDate: '',
        toRemittedDate: ''
    }
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE_REFERRALS:
            return {
                ...state,
                referrals: action.referrals,
                totalResults: action.totalResults,
                totalPage: action.totalPage
            }
        case SET_REFERRALS_PAGESIZE:
            return {
                ...state,
                pageSize: action.pageSize
            }
        case SET_REFERRALS_PAGENUMBER:
            return {
                ...state,
                pageNumber: action.pageNumber
            }
        case SET_REFERRALS_FILTERS:
            return {
                ...state,
                pageNumber: 1,
                filters: {
                    ...state.filters,
                    ...action.filters
                }
            }
        case CLEAR_REFERRALS:
            return initialState
        case SELECT_REFERRAL:
            return {
                ...state,
                selectedReferrals: [...state.selectedReferrals, action.referralId]
            }
        case SELECT_ALL_REFERRALS:
            return {
                ...state,
                selectedReferrals: [...state.selectedReferrals, ...state.referrals.map(ref => ref.depositNumber)]
            }
        case UNSELECT_REFERRAL:
            return {
                ...state,
                selectedReferrals: state.selectedReferrals.filter(ref => ref !== action.referralId)
            }
        case UNSELECT_ALL_REFERRALS:
            return {
                ...state,
                selectedReferrals: []
            }
        default:
            return state;
    }
}